import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { getI18nResources } from './translations';

/**
 * Get initial language from localStorage or default to Arabic
 */
function getInitialLanguage(): string {
  if (typeof window !== 'undefined') {
    const saved = localStorage.getItem('locale');
    if (saved === 'ar' || saved === 'en') {
      return saved;
    }
  }
  return 'ar';
}

i18n
  .use(initReactI18next)
  .init({
    resources: getI18nResources(),
    lng: getInitialLanguage(),
    fallbackLng: 'ar',
    interpolation: {
      escapeValue: false, // React already escapes
    },
  });

/**
 * Change i18next language
 * Called when RTLProvider locale changes
 */
export function changeLanguage(lang: 'ar' | 'en') {
  i18n.changeLanguage(lang);
}

export default i18n;
